
import React, { useState } from 'react';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { Box, Tab, Tabs } from '@mui/material';
import DriverProfileInfo from './DriverProfileForm';
import CorporateAdminInfo from './CorporateProfile';
import EmployeeProfileForm from './EmployeeProfile';
import TenantAdminInfo from './TenantProfile';
import VendorProfileInfo from './VendorProfileForm';
import CustomLabel from 'pages/common/CustomLabel';
import ChangePassword from '../ChangePassword';



const AllDefaultProfile = () => {
    const { user } = useAuthUser();
    const [tab, setTab] = useState(0);

    return (
        <>
            <CustomLabel labelVal={tab === 0 ? 'Profile Update' : 'Change Password'} variantVal="h3-underline" />

            <Tabs
                value={tab}
                onChange={(e, val) => setTab(val)}
                sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
            >
                <Tab label="Profile" />
                <Tab label="Change Password" />
            </Tabs>

            {tab === 0 && (
                <>
                    {user.role === 'DRIVER' && <Box><DriverProfileInfo /></Box>}
                    {user.role === 'CORPORATEADMIN' && <Box><CorporateAdminInfo /></Box>}
                    {user.role === 'TANENTADMIN' && <Box><TenantAdminInfo /></Box>}
                    {user.role === 'VENDOR' && <Box><VendorProfileInfo /></Box>}
                    {(user.role === 'EMPLOYEE' || user.role === 'MANAGER') && <Box><EmployeeProfileForm /></Box>}
                </>
            )}

            {tab === 1 && <ChangePassword />}
        </>
    );
};

export default AllDefaultProfile;

